/* eslint-disable no-unused-vars */
import { Box, CircularProgress, Grid } from '@mui/material'
import { usePresetNodesQuery } from 'apollo/configurator/queries/PresetNodes.generated'
import SortableTree from 'react-sortable-tree'
import 'react-sortable-tree/style.css'
import { IPresetTreeView } from 'ts/interfaces'
import RemovePresetNodePopup from './RemovePresetNodePopup'
import { useRemoveableItem } from './hooks/useRemoveableItem'
import { useTreeState } from './hooks/useTreeState'
import { treeViewStyles } from './styles/treeViewStyles'
import { TreeViewWrapper } from './styling/TreeViewWrapper'
import { createNodePropsGenerator } from './utils/nodePropsGenerator'

declare module 'react-sortable-tree' {
    interface TreeItem {
        hasPresetLoading?: boolean
        presetId?: number
        presetNodeId?: number
        presetNode?: any
    }
}

const TreeView = ({ handleNodeClick, reRenderCallback, presetId, rootNode }: IPresetTreeView) => {
    const { data: presetNodesData, refetch: refetchPresetNodesData } = usePresetNodesQuery({
        variables: { filter: { preset_id: presetId } },
        skip: false
    })

    const { treeState, syncing, uniqueKey, handleNodeSelection, handleTreeChange, setTreeState } =
        useTreeState({
            presetId,
            rootNode,
            handleNodeClick,
            refetchPresetNodesData,
            presetNodesData
        })

    const { removeableItem, setRemoveableItem, handleRemoveSubmit } =
        useRemoveableItem(setTreeState)

    const generateNodeProps = createNodePropsGenerator({
        presetId,
        nodeActionButtonSx: treeViewStyles.nodeActionButton,
        reRenderCallback,
        setRemoveableItem,
        handleNodeSelection
    })

    if (!treeState) return <CircularProgress />

    return (
        <Box sx={treeViewStyles.root}>
            {treeState && (
                <TreeViewWrapper>
                    <Grid container>
                        <Grid item md={12}>
                            {!syncing && (
                                <SortableTree
                                    key={uniqueKey}
                                    canDrag={false}
                                    isVirtualized={false}
                                    scaffoldBlockPxWidth={30}
                                    getNodeKey={({ node }) => node?.id}
                                    treeData={treeState}
                                    onChange={handleTreeChange}
                                    theme={{ rowHeight: 55 }}
                                    generateNodeProps={generateNodeProps}
                                />
                            )}
                        </Grid>
                    </Grid>
                </TreeViewWrapper>
            )}

            {removeableItem && (
                <RemovePresetNodePopup
                    removeableItem={removeableItem}
                    treeState={treeState}
                    onSubmitCallback={handleRemoveSubmit}
                    setRemovableItemCallback={setRemoveableItem}
                />
            )}
        </Box>
    )
}

export default TreeView
